import React from 'react';
import {connect} from 'react-redux';
import {Grid} from 'semantic-ui-react';
import Dimensions from 'react-dimensions';
import _ from 'lodash';
import moment from 'moment';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter} from 'material-ui/Table';
import IconButton from 'material-ui/IconButton';
import IconNavigateBefore from 'material-ui/svg-icons/image/navigate-before';
import IconNavigateNext from 'material-ui/svg-icons/image/navigate-next';

import Tab from '../../components/tab';
import CustomerEmailEventsEmptyState from '../../components/empty-states/customer_email_event_empty_state';
import Loading from '../../components/loading';
import GA from '../../helpers/ga';

import {
	downloadCustomerEmailEvents,
	getShopifyAppConnection
} from './actions';

const PAGE_VIEW_NAME = '/dashboard/emails/activity';

export class CustomerEmailEventsListPage extends React.Component {
	constructor() {
		super();
		this.state = {
			page: 1,
			limit: 10
		};
	}

	componentDidMount() {
		GA.sendPageView(PAGE_VIEW_NAME);
	}

	componentWillMount() {
		this.props.getShopifyAppConnection();
		this.props.downloadCustomerEmailEvents(1, 10);
	}

	getEmptyState(customerEmailEvents) {
		if (_.isNil(customerEmailEvents)) {
			return <Loading />;
		}
		if (customerEmailEvents.length === 0) {
			return <CustomerEmailEventsEmptyState />;
		}
		return <div />;
	}

	render() {
		const {customerEmailEvents,containerHeight} = this.props;
		const paneHeight = containerHeight - 70; // 70px is size of first row;
		const emptyState = this.getEmptyState(customerEmailEvents);

		return (
			<Tab.Pane
				containerHeight={ paneHeight }
				padding={ 15 }
				headerText='Activity'
				subHeaderText='Retrieve information about every email you have sent in the past'
			>
				<Grid textAlign='center'>
					<Grid.Row>
						{ this.generateTable(this,customerEmailEvents) }
						{ emptyState }
					</Grid.Row>
				</Grid>
			</Tab.Pane>
		);
	}

	generateTableHeader() {
		return (
			<TableHeader
				displaySelectAll={false}
				adjustForCheckbox={false}>
				<TableRow>
					<TableHeaderColumn colSpan={2}>Email</TableHeaderColumn>
					<TableHeaderColumn colSpan={4}>Timestamp</TableHeaderColumn>
					<TableHeaderColumn colSpan={2}>Event</TableHeaderColumn>
				</TableRow>
			</TableHeader>
		);
	}

	generateTableBody(ctx, customerEmailEvents) {
		const tableRows = _.map(customerEmailEvents, function(customerEmailEvent) {
			return ctx.generateTableRow(ctx, customerEmailEvent);
		});
		return(
			<TableBody
				displayRowCheckbox={false}
				showRowHover={false}>
				{ tableRows }
			</TableBody>
		);
	}

	generateTableRow(ctx, customerEmailEvent) {
		return (
			<TableRow key={customerEmailEvent._id}>
				<TableRowColumn colSpan={2}>{ customerEmailEvent.email }</TableRowColumn>
				<TableRowColumn colSpan={4}>{ moment(customerEmailEvent.timestamp * 1000).format('LLLL') }</TableRowColumn>
				<TableRowColumn colSpan={2}>{ customerEmailEvent.event }</TableRowColumn>
			</TableRow>
		);
	}

	generateTableFooter(ctx, customerEmailEvents) {
		const visible = (customerEmailEvents.length === 0);

		const limit = ctx.state.limit;
		const page = ctx.state.page;
		const count = ctx.props.count;
		const startingRowCount = (page - 1) * limit + 1;
		const maxEndingRowCount = (page) * limit;
		const endingRowCount = (page * limit > count)? count : maxEndingRowCount;
		const pagingString = startingRowCount + '-' + endingRowCount + ' of ' + count;
		const pagingButtons = ctx.generateTableFooterPageButtons(ctx);
		return (
			<TableFooter
				adjustForCheckbox={false}
			>
				<TableRow>
					<TableRowColumn colSpan="6">
						<p style={{marginBottom: '15px'}} hidden={visible}>
							{ pagingString }
						</p>
					</TableRowColumn>
					<TableRowColumn colSpan="6" style={{textAlign: 'right'}} hidden={visible}>
						{ pagingButtons }
					</TableRowColumn>
				</TableRow>
			</TableFooter>
		);
	}

	generateTableFooterPageButtons(ctx) {
		const limit = ctx.state.limit;
		const page = ctx.state.page;
		const count = ctx.props.count;
		const isFirstPage = (ctx.state.page === 1);
		const isLastPage = (page * limit > count);
		return (
			<div>
				<IconButton
					disabled={isFirstPage}
					onClick={ ctx.moveToPreviousPage }>
					<IconNavigateBefore />
				</IconButton>
				<IconButton
					disabled={isLastPage}
					onClick={ ctx.moveToNextPage }>
					<IconNavigateNext />
				</IconButton>
			</div>
		);
	}

	moveToPreviousPage = () => {
		GA.sendEvent(PAGE_VIEW_NAME, 'click', 'PreviousPageButton', 1);
		this.setState({
			page: this.state.page - 1
		});
		this.props.downloadCustomerEmailEvents(this.state.page-1, this.state.limit);
	}

	moveToNextPage = () => {
		GA.sendEvent(PAGE_VIEW_NAME, 'click', 'NextPageButton', 1);
		this.setState({
			page: this.state.page + 1
		});
		this.props.downloadCustomerEmailEvents(this.state.page+1, this.state.limit);
	}

	generateTable(ctx, customerEmailEvents) {
		if (_.isNil(customerEmailEvents)) {
			customerEmailEvents = [];
		}
		return (
			<Table
				selectable={true}
				multiSelectable={false}>
				{ ctx.generateTableHeader() }
				{ ctx.generateTableBody(ctx, customerEmailEvents) }
				{ ctx.generateTableFooter(ctx, customerEmailEvents) }
			</Table>
		);
	}
}

export function mapsStateToProps ( state ) {
	return {
		customerEmailEvents: state.dashboardEmailsActivityReducer.customerEmailEvents,
		count: state.dashboardEmailsActivityReducer.count
	};
}

export function mapsDispatchToProps ( dispatch ) {
	return {
		getShopifyAppConnection () {
			dispatch( getShopifyAppConnection() );
		},

		downloadCustomerEmailEvents (page, limit) {
			dispatch( downloadCustomerEmailEvents(page, limit) );
		}

	};
}

export default connect(mapsStateToProps, mapsDispatchToProps)( Dimensions()(CustomerEmailEventsListPage) );



// WEBPACK FOOTER //
// ./src/containers/dashboard-emails-activity-page/customer-email-events-list-page.js